export default function AboutAQT() {
  return (
    <section
      className="relative py-24 md:py-32 px-6 md:px-12 lg:px-24
      bg-gradient-to-b from-[#F8FAFC] via-white to-[#F1F5F9] overflow-hidden"
    >
      {/* subtle brand glow */}
      <div className="absolute top-32 inset-x-0 h-[420px] bg-[#0E6F7E]/5 blur-3xl"></div>

      <div className="container mx-auto max-w-7xl relative z-10">
        <div className="max-w-6xl mx-auto">
          {/* Heading */}
          <div className="text-center mb-14">
            <div className="h-1 w-16 bg-gradient-to-r from-[#D4AF37] to-[#C9A631] mx-auto mb-6"></div>
            <h2 className="text-4xl md:text-5xl font-bold text-[#07162E]">
              About AQT Direct Limited
            </h2>
          </div>

          {/* Main Card */}
          <div
            className="bg-white/80 backdrop-blur-xl rounded-3xl
            shadow-[0_30px_80px_rgba(2,8,23,0.12)]
            border border-white/60
            px-8 md:px-14 py-12 md:py-16"
          >
            <div className="space-y-7 text-gray-700 leading-relaxed text-lg">
              <p className="text-xl font-semibold text-[#07162E]">
                AQT Direct Limited is an institutional capital management
                organization focused on building structured, compliant, and
                scalable investment frameworks.
              </p>

              <p>
                The organization specializes in capital raising, deployment, and
                investor servicing across alternative investment categories.
                With a commitment to governance-driven operations, AQT Direct
                works with investment professionals, family offices, and
                institutional investors to create long-term value through
                disciplined capital management.
              </p>

              {/* Feature Blocks */}
              <div className="grid grid-cols-1 md:grid-cols-2 gap-8 my-10">
                <div
                  className="rounded-2xl p-7
                  bg-gradient-to-br from-[#07162E] via-[#0B2A4A] to-[#0E6F7E]
                  text-white"
                >
                  <h3 className="text-xl font-bold mb-4 text-[#1DBF73]">
                    Core Expertise
                  </h3>
                  <ul className="space-y-2 text-gray-200">
                    <li>• Capital raising & deployment</li>
                    <li>• Investment structuring</li>
                    <li>• Investor servicing</li>
                    <li>• Governance frameworks</li>
                  </ul>
                </div>

                <div
                  className="rounded-2xl p-7
                  bg-gradient-to-br from-[#07162E] via-[#0B2A4A] to-[#0E6F7E]
                  text-white"
                >
                  <h3 className="text-xl font-bold mb-4 text-[#1DBF73]">
                    Institutional Standards
                  </h3>
                  <ul className="space-y-2 text-gray-200">
                    <li>• Regulatory compliance</li>
                    <li>• Operational excellence</li>
                    <li>• Investor protection</li>
                    <li>• Transparent reporting</li>
                  </ul>
                </div>
              </div>

              <p>
                AQT Direct&apos;s Partner Program represents an extension of its
                commitment to elevating industry standards. By empowering
                professionals with institutional-grade knowledge and
                frameworks, the organization aims to strengthen the capital
                market ecosystem and build sustainable, trust-based
                relationships across the investment community.
              </p>

              <p className="font-semibold text-[#07162E] text-xl pt-4 border-t border-gray-200">
                This masterclass is an opportunity to learn directly from
                practitioners who understand the complexities of institutional
                capital management and can guide participants toward meaningful
                professional growth.
              </p>
            </div>
          </div>
        </div>
      </div>
    </section>
  );
}
